module.exports = __webpack_public_path__ + "static/8-videos-64bf3f74dfbe761dd27367311d3e0d2d.jpg";